import { Image } from '@ccg/core';
import React$1 from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledTeamList from './TeamList.style.js';

const TeamList = ({
  members,
  link
}) => /*#__PURE__*/React$1.createElement(StyledTeamList, null, members.map(item => /*#__PURE__*/React$1.createElement("div", {
  key: item.id,
  className: "teamList__member"
}, item.image && /*#__PURE__*/React$1.createElement("div", {
  className: "teamList__member-image"
}, /*#__PURE__*/React$1.createElement(Image, {
  ratio: "1:1",
  src: item.image.url,
  srcset: item.image.srcset,
  sizes: "(min-width: 1024px) 300w, (min-width: 768px) 210w, (min-width: 420px) 48vw, 63vw",
  alt: item.image.alt || item.name
})), /*#__PURE__*/React$1.createElement(Typography$1, {
  as: "h3",
  className: "teamList__member-position",
  variant: "subline"
}, item.name), item.position && /*#__PURE__*/React$1.createElement(Typography$1, {
  className: "teamList__member-position",
  variant: "small"
}, item.position))), link && /*#__PURE__*/React$1.createElement("div", {
  className: "teamList__link"
}, /*#__PURE__*/React$1.createElement(Link$1, _extends({
  noHover: true
}, link, {
  icon: null,
  type: "primary"
}), link.label)));

TeamList.propTypes = {
  members: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired,
  link: PropTypes$1.shape()
};
TeamList.defaultProps = {
  link: null
};

export default TeamList;
